module.exports = __webpack_public_path__ + "img/win.d6055fbb.png";